import { noop } from '@capsicum/common';
import {
	type NCWBalanceSanitizedType,
	type PartnerWithImageMap,
	type StakingOperationDetails,
	type UseWalletsBalanceType
} from '@capsicum/socios-core';
import { atom } from 'jotai';

import { type TParticipationRequirements } from '../../hooks/useParticipationRequirement';

export type FeedDataAtomType = {
	favouritePartnerId: string | undefined;
	followedPartners: Array<PartnerWithImageMap> | undefined;
	getOperationDetailsFromPartner: (currencyId?: string) => StakingOperationDetails | undefined;
	isFeedAtomDataLoading: boolean;
	participationRequirement: TParticipationRequirements;
	partnersData: {
		getPartnerBy: (predicate: (p: PartnerWithImageMap) => boolean) => PartnerWithImageMap | undefined;
		partners: Array<PartnerWithImageMap> | undefined;
	};
	walletsBalance: NCWBalanceSanitizedType | undefined | UseWalletsBalanceType;
};

export const DEFAULT_FEED_DATA_VALUE: FeedDataAtomType = {
	favouritePartnerId: undefined,
	followedPartners: undefined,
	getOperationDetailsFromPartner: noop as unknown as (currencyId?: string) => StakingOperationDetails | undefined,
	isFeedAtomDataLoading: false,
	participationRequirement: 'OWNED',
	partnersData: { getPartnerBy: () => undefined, partners: undefined },
	walletsBalance: undefined
};

export const feedDataAtom = atom<FeedDataAtomType>(DEFAULT_FEED_DATA_VALUE);
